// Copyright © 2021 Move Closer
/**
 * Props partial.
 *
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const canBeDisabledProp = {
    disabled: {
        type: Boolean,
        required: false,
        default: false
    }
};
